import { AddressForm } from './types';

export const initAddressFormState: AddressForm = {
  streetAddress: '',
  country: '',
  province: '',
  city: '',
  postalCode: '',
};
